import { useQuery } from '@apollo/client'
import GetStatusChangeReasonGroups from '~/use-cases/status-change-reason-group/get-status-change-reason-groups.graphql'

export const useGetStatusChangeReasonGroups = (
  organizationId: string,
  skip = false,
) => {
  return useQuery(GetStatusChangeReasonGroups, {
    variables: {
      organizationId: organizationId,
    },
    skip: skip,
  })
}
